<template>
  <form-field :name="field.name">
    <black-packages
      v-model="input"
      v-bind="field.props"
    />
  </form-field>
</template>

<script>
import formField from '@/mixins/form-field'

export default {
  components: {
    BlackPackages: () => import(/* webpackChunkName: "blackPackages" */ '@/components/BlackPackages'),
  },
  mixins: [formField],
  data: function () {
    return {
      input: {},
    }
  },
  watch: {
    input: function (val) {
      this.field.value = val
    },
  },
}
</script>
